import { type StoreName } from '@bluebrick/discounts-service-module'
import { type Store } from '@/types'

export function supportsAdvancedOperations(storeName: StoreName) {
	return (storeName.toLowerCase().startsWith('steam') || storeName.toLowerCase().startsWith('nintendo')) && storeName !== 'nintendo_switch_china'
}

export function sort(stores: Store[]): Store[] {
	const advancedStores = stores.filter((store) => supportsAdvancedOperations(store.id)).sort((a, b) => b.displayName.localeCompare(a.displayName))
	const otherStores = stores.filter((store) => !supportsAdvancedOperations(store.id)).sort((a, b) => b.displayName.localeCompare(a.displayName))

	return [...advancedStores, ...otherStores]
}
